import { SUPABASE_URL, getDbHeaders, getAnonHeaders } from "./client";

// -- SCCO DB helpers ----------------------------------------------------------
// Used by LoginScreen (unauthenticated) — no is_admin flag exposed
export async function dbLoadSCCO() {
  const res = await fetch(
    SUPABASE_URL + "/rest/v1/scco?order=name.asc&select=id,name,badge,active",
    { headers: getAnonHeaders() }
  );
  if (!res.ok) return [];
  return res.json();
}

// Used post-login by UA users — includes is_admin for admin panel
export async function dbLoadSCCOFull() {
  const res = await fetch(
    SUPABASE_URL + "/rest/v1/scco?order=name.asc&select=id,name,badge,active,is_admin",
    { headers: await getDbHeaders() }
  );
  if (!res.ok) return [];
  return res.json();
}

export async function dbAddSCCO(name, badge) {
  const res = await fetch(SUPABASE_URL + "/rest/v1/scco", {
    method: "POST",
    headers: await getDbHeaders({ "Prefer": "return=representation" }),
    body: JSON.stringify({ name: name.trim(), badge: (badge || "").trim().toUpperCase(), active: true }),
  });
  if (!res.ok) { console.error("SCCO add error", await res.text()); return null; }
  const rows = await res.json();
  return rows[0] || null;
}

export async function dbDeleteSCCO(id) {
  await fetch(SUPABASE_URL + "/rest/v1/scco?id=eq." + id, {
    method: "DELETE",
    headers: await getDbHeaders(),
  });
}

export async function dbLoadContacts() {
  const res = await fetch(
    SUPABASE_URL + "/rest/v1/airline_contacts?order=airline.asc,name.asc&select=id,airline,name,phone",
    { headers: await getDbHeaders() }
  );
  if (!res.ok) return [];
  return res.json();
}

// Upsert a phone number for a specific airline + department (name field)
export async function dbUpsertContactPhone(airline, deptName, phone) {
  const checkRes = await fetch(
    SUPABASE_URL + "/rest/v1/airline_contacts?airline=eq." + encodeURIComponent(airline) + "&name=eq." + encodeURIComponent(deptName) + "&select=id",
    { headers: await getDbHeaders() }
  );
  const existing = checkRes.ok ? await checkRes.json() : [];
  if (existing.length > 0) {
    const res = await fetch(
      SUPABASE_URL + "/rest/v1/airline_contacts?id=eq." + existing[0].id,
      { method: "PATCH", headers: await getDbHeaders(), body: JSON.stringify({ phone: phone || null }) }
    );
    if (!res.ok) console.error("Contact PATCH error:", res.status, await res.text());
    return res.ok;
  } else {
    const res = await fetch(SUPABASE_URL + "/rest/v1/airline_contacts", {
      method: "POST",
      headers: await getDbHeaders({ "Prefer": "return=minimal" }),
      body: JSON.stringify({ airline, name: deptName, phone: phone || null }),
    });
    if (!res.ok) console.error("Contact POST error:", res.status, await res.text());
    return res.ok;
  }
}
